import { createSlice } from '@reduxjs/toolkit'
import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'

const initialState = {
  isLoading: false,
  siteSetting: {},
  siteSettingMap: undefined,
  keywords: {},
  hasLandingURL: true,
  isIndividual: true,
  errors: {},
  columnHeights: {},
}

export const fetchBizChannelSiteSetting = createAxiosThunk(
  'dashboard/keywordLandingUrlEdit/fetchBizChannelSiteSetting',
  async () => {
    const {
      data: { content },
    } = await api.ad.getBizChannels()
    return api.response(
      content.reduce(
        (
          accumulator,
          { id, siteUrl: { pcSiteYn, mobileSiteYn, individualSettingYn } }
        ) => {
          accumulator[id] = {
            hasPcSite: pcSiteYn === 'Y',
            hasMobileSite: mobileSiteYn === 'Y',
            isIndividual: individualSettingYn === 'Y',
          }
          return accumulator
        },
        {}
      )
    )
  }
)

const keywordLandingUrlEditSlice = createSlice({
  name: 'dashboard/keywordLandingUrlEdit',
  initialState,

  reducers: {
    reset: () => initialState,
    activate: (state, { payload: { ids, siteSetting } }) => {
      state.siteSetting = siteSetting
      state.isIndividual = siteSetting.isIndividual
      state.keywords = ids.reduce(
        (obj, id) => ({
          ...obj,
          [id]: {},
        }),
        {}
      )
    },
    setIndividual: (state, { payload }) => {
      state.isIndividual = payload
      state.keywords = Object.keys(state.keywords).reduce(
        (previousValue, currentValue) => {
          previousValue[currentValue] = {}
          return previousValue
        },
        {}
      )
      state.errors = {}
    },
    setHasLandingURL: (state, { payload }) => {
      state.hasLandingURL = payload
    },
    setPcURL: (state, { payload: { id, landingUrl } }) => {
      state.keywords[id].pcSite = landingUrl
    },
    setMobileURL: (state, { payload: { id, landingUrl } }) => {
      state.keywords[id].mobileSite = landingUrl
    },
    setUnifiedURL: (state, { payload: { id, landingUrl } }) => {
      state.keywords[id].unifiedSite = landingUrl
    },
    setErrors: (state, { payload: errors }) => {
      state.errors = errors
    },
    setColumnHeights: (state, { payload: { id, height } }) => {
      state.columnHeights[id] = height
    },
  },

  extraReducers: builder => {
    builder.addCase(fetchBizChannelSiteSetting.pending, state => {
      state.isLoading = true
    })

    builder.addCase(
      fetchBizChannelSiteSetting.fulfilled,
      (state, { payload }) => {
        state.siteSettingMap = payload
        state.isLoading = false
      }
    )

    builder.addCase(fetchBizChannelSiteSetting.rejected, state => {
      state.isLoading = false
    })
  },
})

export default keywordLandingUrlEditSlice.reducer

export const {
  reset,
  activate,
  setHasLandingURL,
  setPcURL,
  setMobileURL,
  setUnifiedURL,
  setErrors,
  setIndividual,
} = keywordLandingUrlEditSlice.actions
